export default __webpack_public_path__ + "static/media/troy nehls.5bece384.jpg";